import type { ContentBlock, PageResponse } from '../../generated/api/models.js';

export const getProductDetailsContentBlock = (productPage: PageResponse): ContentBlock | undefined => {
  return productPage.contentBlocks.find(({ contentBlockType }) => contentBlockType === 'CB-ProductDetails');
};
